import React, { useEffect } from "react";
import TableLayout from "../../../../../_metronic/layout/components/table/TableLayout";
import { roles } from "../../../../App";
import { useList } from "../../../common/hooks";
import { DEPOSITS_CONTEXT } from "../../helpers/ModuleHelpers";
import { useModuleContext } from "../../ModuleContext";
import { depositsColumns } from "../../tables/deposits/deposits";

import * as actions from "../../_redux/deposits/actions";
import { actionTypes } from "../../_redux/deposits/slice";
import DepositsFilter from "./filters/DepositsFilter";
import { useSelector } from "react-redux";
const DepositsList = () => {
  const user = useSelector((s) => s["auth"].user);

  const {
    metadata,
    entities,

    isLoading,
  } = useList({
    CONTEXT: DEPOSITS_CONTEXT,
    actions,
  });

  useEffect(() => { }, [isLoading]);

  const filteredEntities = entities.filter((deposit) => Number(deposit.user_id) === Number(user.id));

  // console.log(user);

  return (
    <>
      {/* <TableLayout
        Filter={DepositsFilter}
        columns={depositsColumns}
        cardTitle={"DEPOSITS"}
        entities={entities}
        metadata={metadata}
        isLoading={isLoading}
        resource={"deposits"}
        useModuleContext={useModuleContext}
        CONTEXT={DEPOSITS_CONTEXT}
        actions={actions}
        actionTypes={actionTypes}
        acceptedRoles={[roles.super_admin]}
      /> */}
      {user.roles.includes(roles.super_admin) ?
        <TableLayout
          Filter={DepositsFilter}
          columns={depositsColumns}
          cardTitle={"DEPOSITS"}
          entities={entities}
          metadata={metadata}
          isLoading={isLoading}
          resource={"deposits"}
          useModuleContext={useModuleContext}
          CONTEXT={DEPOSITS_CONTEXT}
          actions={actions}
          actionTypes={actionTypes}
          acceptedRoles={[roles.super_admin]}
        />
        :
        filteredEntities.length > 0 ?
        <TableLayout
          Filter={DepositsFilter}
          columns={depositsColumns}
          cardTitle={"DEPOSITS"}
          entities={filteredEntities}
          metadata={metadata}
          isLoading={isLoading}
          resource={"deposits"}
          useModuleContext={useModuleContext}
          CONTEXT={DEPOSITS_CONTEXT}
          actions={actions}
          actionTypes={actionTypes}
          acceptedRoles={[roles.super_admin]}
        />
        : null
      }
    </>
  );
};

export default DepositsList;
